import PropTypes from 'prop-types';

const friendlyFileSize = (bytes) => {
  if (!bytes) return '';
  // `bytes` may be a string: Asset.dataFileSize is exposed as GraphQL BigInt
  // (serialized as a JSON string) so large video assets don't overflow Int
  // (eng-maintenance#20983). Coerce before doing arithmetic.
  const value = Number(bytes);
  if (!Number.isFinite(value) || value <= 0) return '';
  const maxSize = Math.floor(Math.log(value) / Math.log(1024));
  const friendlySize = ['B', 'KB', 'MB', 'GB', 'TB'][maxSize];
  const maxSizeBytes = (value / 1024 ** maxSize).toFixed(2) * 1.0;
  return `${maxSizeBytes} ${friendlySize}`;
};

const FriendlyFileSize = (props) => {
  const { bytes } = props;
  const fileSize = friendlyFileSize(bytes);
  return <span>{fileSize}</span>;
};

FriendlyFileSize.propTypes = {
  // BigInt-backed dataFileSize arrives as a string; accept both.
  bytes: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
};

export { FriendlyFileSize };
